import Quill from "quill";

const Inline = Quill.import("blots/inline");

export class SubScript extends Inline {
  static blotName = "subscript";
  static tagName = ["SUB"];
  static create(value) {
    if (value === "subscript") {
      return document.createElement("sub");
    } else {
      return super.create(value);
    }
  }

  static formats(domNode) {
    if (domNode.tagName === "SUB") return "subscript";
    return undefined;
  }
}
